import { fetchPreviousTimeseriesAssetMedia, fetchNextTimeseriesAssetMedia, fetchNearestTimeseriesAssetMedia, fetchLatestServiceMedia, fetchFirstServiceMedia } from "@/services/assets/services"
import type { IWebCOOSElement } from "@/services/assets/types"
import { type UseQueryResult, useQuery } from "@tanstack/react-query"

export type WebCOOSBrowseMediaProps = {
    token: string
    apiUrl: string
    apiVersion: string
    serviceIdentifier: string
    date: Date | string | number
    withinHours?: number
    direction?: 'next' | 'previous' | 'nearest' | 'first' | 'last'
    nameOrSlugPrefix?: string
    notNameOrSlugPrefix?: string
    count?: number
    enabled?: boolean
}

export const useTimeSeriesAssetBrowse = ({
    serviceIdentifier,
    count = 1,
    enabled = true,
    date,
    direction,
    withinHours,
    nameOrSlugPrefix,
    notNameOrSlugPrefix,
    ...props
}: WebCOOSBrowseMediaProps): UseQueryResult<IWebCOOSElement | { message: string }> => {
    const queryResult = useQuery({
        queryKey: ['browse', serviceIdentifier, nameOrSlugPrefix, notNameOrSlugPrefix, date.toString(), direction, enabled, withinHours, count],
        enabled,
        queryFn: async ({ signal, queryKey }): Promise<IWebCOOSElement | { message: string }> => {
            console.log('queryKey', queryKey)
            console.log(`getting ${direction} from ${date}`)
            const elements = direction === 'previous'
                ? await fetchPreviousTimeseriesAssetMedia({
                    ...props,
                    signal,
                    serviceIdentifier,
                    before: date,
                    nameOrSlugPrefix,
                    notNameOrSlugPrefix
                })
                : direction === 'next'
                    ? await fetchNextTimeseriesAssetMedia({
                        ...props,
                        signal,
                        serviceIdentifier,
                        after: date,
                        withinHours,
                        count,
                        nameOrSlugPrefix,
                        notNameOrSlugPrefix
                    })
                    : direction === 'first'
                        ? await fetchFirstServiceMedia({
                            ...props,
                            signal,
                            serviceIdentifier,
                            nameOrSlugPrefix,
                            notNameOrSlugPrefix
                        })
                        : direction === 'last'
                            ? await fetchLatestServiceMedia({
                                ...props,
                                signal,
                                serviceIdentifier,
                                nameOrSlugPrefix,
                                notNameOrSlugPrefix
                            })
                            : await fetchNearestTimeseriesAssetMedia({
                                ...props,
                                signal,
                                serviceIdentifier,
                                withinHours,
                                date,
                                nameOrSlugPrefix,
                                notNameOrSlugPrefix
                            })
            return Array.isArray(elements) ? elements[0] : elements;

        }
    })

    return queryResult
}
